export default __webpack_public_path__ + "static/media/dashbaord_Lovrican-logo-white.346e7e62.svg";